export default __webpack_public_path__ + "static/dotpattern2-e6fa5779d9e6bc6c06dfa6a165967f45.svg";